import { makeRequest } from "../components/utils/APIsUtils/httpsUtils";
import { BaseService } from "./BaseService";

export default class LearningPathManagementService extends BaseService {

    static async fetchLinkedLearningPathsOfCourse(courseId) {
        const response = await makeRequest({
            method: 'GET',
            endpoint: `/admin/api/v1/learning-paths/courses/${courseId}`
        });

        if (response != 'ERR_NETWORK' && response?.data) return response;
    }
}
